import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import enLabels from 'react-phone-number-input/locale/en.json'
import frLabels from 'react-phone-number-input/locale/fr.json'

export const usePhoneLabels = () => {
  const { i18n } = useTranslation()

  return useMemo(() => {
    switch (i18n.language) {
      case 'fr':
        return frLabels
      case 'en':
      default:
        return enLabels
    }
  }, [i18n.language])
}
